export default "__VITE_ASSET__DaRBehr7__"